import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.aq{align-items:flex-start;}.ssr-plugin'
import '.j{gap:1.5rem;}.ssr-plugin'
import '.e5{background:var(--palette-white);}.ssr-plugin'
import '.q{flex-direction:row;}.ssr-plugin'
import '.fv{justify-content:flex-start;}.ssr-plugin'
import '.gg{gap:2.5rem;}.ssr-plugin'
import '.ar{flex-wrap:wrap;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.k3{font-size:4rem;}.ssr-plugin'
import '.ci{font-weight:700;}.ssr-plugin'
import '.k4{line-height:100%;}.ssr-plugin'
import '.hj{margin:0px;}.ssr-plugin'
import '.a3{color:var(--brand-secondary);}.ssr-plugin'
import '.a4{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'

export interface NutshellItem {
  total: string | number
  subtitle: string
}

export interface NutshellProps {
  heading: string
  items: NutshellItem[]
  style?: Style
}

export const Nutshell = ({ heading, items, style }: NutshellProps) => {
  return (
    <styled.div className="a b aq j e5"
      data-testid="nutshell"
      style={{
        ...style,
      }}
    >
      {/* Heading */}
      <Title.H4
        style={{
          color: 'var(--brand-secondary)',
          textAlign: 'center',
          margin: 0,
        }}
      >
        {heading}
      </Title.H4>

      {/* Data Points Container */}
      <div className="a q fv aq gg ar"
      >
        {items.map((item, index) => (
          <div className="a b r s"
            key={index}
          >
            <div className="k3 ci k4 hj a3 a4"
            >
              {item.total}
            </div>

            {/* Subtitle */}
            <Text.Medium
              style={{
                color: 'var(--brand-secondary)',
                opacity: 0.6,
                margin: 0,
                textAlign: 'center',
              }}
            >
              {item.subtitle}
            </Text.Medium>
          </div>
        ))}
      </div>
    </styled.div>
  )
}
